var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuturesCopyTrading = function SvgFuturesCopyTrading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.787 12 2.15-8.02L3.61 5.07a1 1 0 0 0-.64 1.255zM21.962 5.602 17.82 21.056a1 1 0 0 1-1.224.707L4.038 18.398l4.4-16.42zm-11.733 4.955h.002l-2.563 2.359 1.335 1.455 2.564-2.36 2.582 2.806 4.16-3.833-1.332-1.452-2.714 2.495-2.581-2.807z"
  })));
};
export default SvgFuturesCopyTrading;